import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "tabs" }
const _hoisted_2 = { class: "tabs__header" }
const _hoisted_3 = ["onClick"]

import {useSlots, ref, provide, watch} from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TabsWrapper',
  props: {
  activeTab: Number
},
  setup(__props) {

const props = __props

const slots = useSlots()
const tabTitles = ref(slots.default().map(tab => tab.props.title))
const selectedTitle = ref(tabTitles.value[props.activeTab])

provide('selectedTitle', selectedTitle)

watch(() => props.activeTab, (newValue) => {
  selectedTitle.value = tabTitles.value[newValue];
});

const clickTab = (index) => {
  selectedTitle.value = tabTitles.value[index];
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabTitles.value, (title, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: _normalizeClass(["tabs__item", { selected: selectedTitle.value === title}]),
          onClick: ($event: any) => (clickTab(index))
        }, _toDisplayString(title), 11, _hoisted_3))
      }), 128))
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})